function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      enableBackground: "accumulate"
    },
    d: "m 49.625002,958.37952 a 3.0003,3.0003 0 0 0 -0.7188,0.1875 l -37,14.71875 a 3.0003,3.0003 0 0 0 -1.9062,2.8125 l 0,52.56253 a 3.0003,3.0003 0 0 0 1.9062,2.7812 l 37,14.7188 a 3.0003,3.0003 0 0 0 2.1876,0 l 36.999997,-14.7188 a 3.0003,3.0003 0 0 0 1.9062,-2.7812 l 0,-52.56253 a 3.0003,3.0003 0 0 0 -1.9062,-2.8125 L 51.093802,958.56702 a 3.0003,3.0003 0 0 0 -1.4688,-0.1875 z m 0.375,6.21875 28.875,11.5 -28.875,11.46873 -28.875,-11.46873 28.875,-11.5 z m -34,15.90623 31,12.3438 0,46.0937 -31,-12.3437 0,-46.0938 z m 68,0 0,46.0938 -31,12.3437 0,-46.0937 31,-12.3438 z",
    fillOpacity: 1,
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.40f4375d2cc8e8587ec1076db962dbcc.svg";
export { ForwardRef as ReactComponent };